<template>
    <b-row>
        <b-row v-for="(field, index) in fields" :key="index">
            <b-col class="ammount_footer">
                <p class="light-txt">{{ $t(field.labelKey) }}</p>
                <p class=""><span class="pe-1">&#8377</span>{{ grossvalues[field.model] }}</p>
            </b-col>
        </b-row>
        <b-row>
            <b-col offset-lg="3" class="d-flex align-items-center justify-space-end px-0 text-center">
                <div class="totaldiv1">
                    <p class="component-heading">{{ grossvalues.totalqty }}</p>
                    <p v-if="flagval" class="light-txt">
                        {{ $t('grn.itemspartofthisgrn') }}
                    </p>
                    <p v-else> {{ $t('grn.itemspartofthisissue') }}</p>
                </div>
                <div class="totaldiv2">
                    <p class="component-heading"><span class="pe-1">&#8377</span>{{ grossvalues.netamount }}</p>
                    <p class="light-txt mt-3">{{ $t('grn.value') }}</p>
                </div>
            </b-col>
            <!-- <b-col class="d-flex align-items-center mt-5">
                <p class="light-txt">{{ $t('grn.grandtotal') }}</p>
            </b-col>
      
            <b-col  class="d-flex px-0">
                <div class="totaldiv1">
                    <p class="component-heading">{{ grossvalues.totalqty }}</p>
                    <p class="light-txt">{{ $t('grn.itemspartofthisissue') }}</p>
                </div>
                <div class="totaldiv2">
                    <p class="component-heading"><span class="pe-1">&#8377</span>{{ grossvalues.netamount }}</p>
                    <p class="light-txt mt-3">{{ $t('grn.value') }}</p>
                </div>
            </b-col> -->
        </b-row>
    </b-row>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, reactive, watch } from "vue";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import InputNumber from '../../../../../components/FormComponents/InputNumber.vue'
export default defineComponent({

    components: {
        TextField,
        InputNumber
    },

    props: {
        grossvalue: {
            type: Object,
            default: () => ({}),
        },
        flagval: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const grossvalues = reactive({
            grossamount: 0.0,
            taxamount: 0.0,
            totaldiscountamount: 0.0,
            transportcharges: 0.0,
            servicecharges: 0.0,
            othercharges: 0.0,
            netamount: 0.0,
            totalqty: 0.0,
            freightcharges: 0.0,
        });

        // Watch for changes in props.grossvalue and update grossvalues accordingly
        // watch(props, (newValue) => {
        //     Object.assign(grossvalues, newValue.grossvalue);
        // });

        watch(() => props.grossvalue, (newValue) => {
            const formatValue = (value) => {
                return parseFloat(value).toFixed(2);
            };

            const formattedValues = {
                grossamount: formatValue(newValue.grossamount),
                totaldiscountamount: formatValue(newValue.totaldiscountamount),
                taxamount: formatValue(newValue.taxamount),
                transportcharges: formatValue(newValue.transportcharges),
                servicecharges: formatValue(newValue.servicecharges),
                othercharges: formatValue(newValue.othercharges),
                netamount: formatValue(newValue.netamount),
                totalqty: (newValue.totalqty),
                freightcharges: formatValue(newValue.freightcharges),
            };

            Object.assign(grossvalues, formattedValues);
        }, { deep: true });

        const fields = [
            { labelKey: 'grn.grossamount', name: 'grossamount', model: 'grossamount' },
            { labelKey: 'grn.discountamount', name: 'Discount Amount', model: 'totaldiscountamount' },
            { labelKey: 'grn.taxamount', name: 'TAX AMOUNT', model: 'taxamount' },
            { labelKey: 'grn.transportationcharges', name: 'TRANSPORTATION', model: 'transportcharges' },
            { labelKey: 'grn.freightcharges', name: 'FREIGHTCHARGES', model: 'freightcharges' },
            { labelKey: 'grn.servicecharges', name: 'SERVICE CHARGES', model: 'servicecharges' },
            { labelKey: 'grn.othercharges', name: 'OTHER CHARGES', model: 'othercharges' },
        ];
        return {
            grossvalues,
            fields
        };
    },
});

</script>

<style>
.totaldiv1 {
    background-color: #F7F7F9;
    padding: 10px;
    width: 120px;
    text-align: center;
    height: 90px;
    border-radius: 5px;
}

.totaldiv2 {
    background-color: #EAECF1;
    padding: 10px;
    width: 150px;
    height: 90px;
    text-align: center;
    border-radius: 5px;
}

.ammount_footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}
</style>